import { TrackingInstrumentTypeWithGC } from "@flexidao/dto";

export const formatTrackingInstrumentTypeWithGc = (
    trackingInstrumentType: TrackingInstrumentTypeWithGC,
    options?: {
        plural?: boolean;
    },
): string => {
    switch (trackingInstrumentType) {
        case TrackingInstrumentTypeWithGC.EAC:
            return `EAC cancellation${options?.plural ? "s" : ""}`;
        case TrackingInstrumentTypeWithGC.Attestation:
            return `Attestation${options?.plural ? "s" : ""}`;
        case TrackingInstrumentTypeWithGC.GC:
            return `GC cancellation${options?.plural ? "s" : ""}`;
    }
};
